import Footer from "../components/Footer";
import PointsCard from "../components/PointsCard";
import { WebpTermsofuseBg } from "../assets";
import { addAnimation } from "../utils/addAnimation";

export default function TermsUse() {
  return (
    <>
      <section className="about__hero">
        <img
          loading="lazy"
          className="about__hero__img"
          src={WebpTermsofuseBg}
          alt=" At AFF, we pioneer evocative aromas and tastes that inspire and endure. As an ambitious trailblazer in Asia, we envision a world where every Scent tells a story, and every Flavor is a journey AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey ,AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey,advancedffwebsite aff  aff website   advancedff advancedff.com advancedff advancedff advancedgg advancedff advancedgg affwebsite  Advanced Flavors & Fragrances Pte. Ltd. Advanced Flavors & Fragrances Pte. Ltd. Advanced Flavors and  Flavors & Fragrances Pte. Ltd. advnacedff   flavour flavour singapore advancedff-Image Containg Buildings"
        />
        <div className="about__hero__content">
          <div className="about__hero__content__heading">Terms of Use</div>
        </div>
      </section>
      <section className="natural__flavor__container">
        <div className="natural__flavor__container__wraper">
          <div className="natural__flavor__container__wraper__contant">
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Welcome Aboard!")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                "Hello and welcome to Advanced Flavors & Fragrances! Whether you’re navigating through our main website or exploring our presence on social media, know that we are thrilled to have you. But before you dive into the world of flavors and fragrances, there are some terms you should be familiar with. We have tried to make them as straightforward as possible."
              )}
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Our Language, Your Understanding")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `When we say "we", "us", or "our", we are talking about Advanced Flavors & Fragrances. If you continue to use our platforms, it means you agree to these Terms and our Privacy Policy.`
              )}

              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Change is the Only Constant")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `Life evolves and so do our terms. We may update them now and then, and when we do, we’ll make sure to notify you. Keep an eye on the date at the top of this page to know when we last made changes.`
              )}
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Your Creative Rights and Ours")}
            </div>
            <div className="scentsectionall__content__points">
              <PointsCard
                heading="Copyright Matters"
                text="Everything you see here – from text and images to our secret sauce of formulas – is owned by us. Please do not copy, redistribute, or modify anything without our written permission."
              />
              <PointsCard
                heading="Trademarks"
                text="Crafting a fragrance that reflects brand values is key, making the fragrance an integral part of the brand's story."
              />
            </div>
            <br />
            <br />
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("What About Third-Parties?")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `If you see content from third parties or links to other sites, know that we do not have control over those. We ca not vouch for the accuracy or reliability of third-party information, so proceed with caution. `
              )}
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Geographic Availability")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `While we would love to be everywhere, our products and services may not be available in your part of the world. Eligibility for what we offer is ultimately up to us.`
              )}
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("No Guarantees, But We Try Our Best")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `We aim for accuracy and reliability, but we can’t promise that our services will be error-free or uninterrupted. We disclaim any warranties to the extent permitted by law and ca not be held responsible for any loss or damage that arises from your use of our sites or services.`
              )}
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Your Info is Safe, But Not Secret")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `We’re committed to protecting your privacy. However, if you share any ideas or suggestions with us, know that they'll become our property and we are free to use them without any obligation to keep them confidential.`
              )}
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Singapore at the Helm")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `Your use of our platforms and any disputes arising from them are governed by Singapore law, and you agree to submit to the jurisdiction of the Singapore courts.`
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
